import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "@mui/material";
// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Button,
  Row,
  MenuProps,
  Skeleton,
  Table,
  Typography,
} from "antd";

// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";

// --------------------- Import Styles ---------------------
import { Container } from "./styles";
// --------------------- Import Components ---------------------
import { Columns } from "./components/Columns";
// --------------------- Import Hooks ---------------------

// import { useGerenciarFiltros } from "./hooks/useGerenciarFiltros";
// --------------------- Import Utéis ---------------------
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { useQueryParams, NumberParam, StringParam } from "use-query-params";
import { useRepresentantes } from "./hooks/useRepresentantes";
import ModalEditar from "./components/ModalEditar";
import ModalAdicionarRepresentante from "./components/ModalAdicionarRepresentante";
import { useValidarRepresentante } from "./hooks/useValidarRepresentante";
import { useExcluirRepresentante } from "./hooks/useExcluirRepresentante";
import { useError } from "../../uteis/mensagens/useError";
import { useSuccess } from "../../uteis/mensagens/useSuccess";
import { useNavigate } from "react-router-dom";
import { useMessage } from "../../uteis/mensagens/useMessage";
import ModalAdicionarProprietario from "./components/ModalAdicionarProprietario";

export default function ViewRepresentantes() {
  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  // Controle de Paginação
  const currentPage = 1;

  // Definições para mobile
  const isMobile = useMediaQuery("(max-width:600px)");

  // Recupera os valores enviado pela URL (id do apartamento, nome empreendimento e nome apartamento)
  const [queryParams] = useQueryParams({
    cotaUsuarioId: NumberParam,
    nomeEmpreend: StringParam,
    numeroCota: NumberParam,
  });
  const cotaUsuarioId = queryParams.cotaUsuarioId;
  const nomeEmpreend = queryParams.nomeEmpreend;

  // Verificação de permissaão
  const { isLoading: isTokenLoading, isValid } = usePermissao("USU");

  // Armazena
  const [representanteId, setRepresentanteId] = useState<number | null>(null);
  // Armazena
  const [usuarioId, setUsuarioId] = useState<number | null>(null);

  const { representantes, isLoading } = useRepresentantes(cotaUsuarioId);

  const { validarRepre, error, success, resetError, resetSuccess } =
    useValidarRepresentante();

  const {
    excluirRepre,
    error: errorExcluir,
    success: sucessExcluir,
    resetError: resetErrorExcluir,
    resetSuccess: resetSuccessExcluir,
  } = useExcluirRepresentante();

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Validar
      case "1":
        validarRepre(representanteId);

        break;
      // Editar
      case "2":
        editarModal();
        break;
      // Excluir
      case "3":
        excluirRepre(representanteId);
        break;
    }
  };
  // Traz as informações  OnClick, origem , nome e id do Empreendimento além do nome do empreendimento, ao clickar na linha especifica
  const columns = Columns(onClick, setRepresentanteId, setUsuarioId);

  // State de abertura e fechamento do modal (Editar Apartamento)
  const [isModalCriarOpen, setIsModalCriarOpen] = useState(false);

  // Funçao para abrir o modal (Editar Apartamento)
  const criarModal = () => {
    setIsModalCriarOpen(true);
  };

  // Funçao para fechar o modal (Editar Apartamento)
  const handleCriarFechar = () => {
    setIsModalCriarOpen(false);
  };

  // State de abertura e fechamento do modal (Editar Apartamento)
  const [isModalEditarOpen, setIsModalEditarOpen] = useState(false);

  // Funçao para abrir o modal (Editar Apartamento)
  const editarModal = () => {
    setIsModalEditarOpen(true);
  };

  // Funçao para fechar o modal (Editar Apartamento)
  const handleEditarFechar = () => {
    setIsModalEditarOpen(false);
  };

  const [openModalProprietario, setOpenModalProprietario] = useState(false);
  const handleOpenModalProprietario = () => {
    setOpenModalProprietario(!openModalProprietario);
  };
  // Exibe a Mensagem de Feedback
  const { showSuccess, showError, contextHolder } = useMessage();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);
  const [errorExcluirDisplayed, setErrorExcluirDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Hook de navegação do React Router
  const navigate = useNavigate();
  useEffect(() => {
    if (success && !successDisplayed) {
      // Mensagem de sucesso

      showSuccess(success);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        navigate(0);
      }, 2000);
    }
    if (sucessExcluir && !successDisplayed) {
      // Mensagem de sucesso
      showSuccess(sucessExcluir);
      setSuccessDisplayed(true);

      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        navigate(0);
      }, 2000);
    }

    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        resetError();
        setErrorDisplayed(false);
      }, 3000);
    }
    if (errorExcluir && !errorExcluirDisplayed) {
      showError(errorExcluir);
      setErrorExcluirDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        resetErrorExcluir();
        setErrorExcluirDisplayed(false);
      }, 3000);
    }
  }, [
    success,
    error,
    sucessExcluir,
    showSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    errorExcluirDisplayed,
    errorExcluir,
    navigate,
    resetError,
    resetErrorExcluir,
  ]);

  return (
    <>
      {(isLoading && isTokenLoading) || !isValid ? (
        <Skeleton active />
      ) : (
        <Container>
          <>{contextHolder}</>

          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a href={`/inicio`}>
                  <ArrowBackIcon color="primary" />
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />

                <Title
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                    fontSize: isMobile ? "1rem" : "2rem",
                    color: "rgb(0, 54, 68)",
                  }}
                  level={3}
                >
                  Representantes de {nomeEmpreend}
                </Title>
              </Flex>
            </Col>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end", // Alinha os botões à direita
                alignItems: "center",
                width: isMobile ? "100%" : "85%",
                gap: "20px", // Espaço entre os botões
              }}
            >
              <Button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "auto",
                }}
                onClick={criarModal}
                type="primary"
              >
                + Representante
              </Button>
              <Button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "auto",
                }}
                onClick={handleOpenModalProprietario}
                type="primary"
              >
                + Proprietário
              </Button>
            </div>
          </Row>
          <Row>
            <Col span={isMobile ? 0 : 1}></Col>
            <Col
              span={20}
              style={{
                marginTop: isMobile ? 5 : 20,
                marginBottom: isMobile ? 0 : 50,
              }}
            >
              <Flex
                style={{
                  width: isMobile ? "auto" : "100%",
                  overflow: "auto",
                  marginLeft: 30,
                }}
              >
                <Table
                  columns={columns}
                  dataSource={representantes}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: isMobile ? "auto" : "100%",
                    maxWidth: isMobile ? "none" : "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage }}
                />
              </Flex>
            </Col>
            <Col span={1}></Col>
          </Row>
          <ModalAdicionarRepresentante
            isModalOpen={isModalCriarOpen}
            handleFechar={handleCriarFechar}
            cotaUsuarioId={cotaUsuarioId}
          />
          <ModalAdicionarProprietario
            isModalOpen={openModalProprietario}
            handleFechar={handleOpenModalProprietario}
            cotaUsuarioId={cotaUsuarioId}
          />
          <ModalEditar
            isModalOpen={isModalEditarOpen}
            handleFechar={handleEditarFechar}
            usuarioId={usuarioId}
            representanteId={representanteId}
          />
        </Container>
      )}
      ;
    </>
  );
}
